"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toInvestorsRedirectBlockSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toInvestorsRedirectBlockSlice = function (data, logger) {
    var title = logger.required(fields_1.toText(data.primary.title));
    var cta = logger.required(field_groups_1.toCta(data.primary, logger));
    if (title && cta) {
        return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.InvestorsRedirectBlock)), { title: title, text: fields_1.toText(data.primary.text), cta: cta }));
    }
    else {
        return undefined;
    }
};
exports.toInvestorsRedirectBlockSlice = toInvestorsRedirectBlockSlice;
//# sourceMappingURL=investors-redirect-block-slice.js.map